import React from "react";
import Image from "next/image";
import PropTypes from "prop-types";

const API_PATH = "http://127.0.0.1:8080/api/v1/get-pic"

const VALID_EXTENSIONS = [
  "avif", 
  "webp", 
  // "jxl", 
];

const  createExtensionImage = (src, extension) => {
  const srcSplit = src.split(".");
  const oe = srcSplit.pop();
  let pathName = srcSplit.join('.');
  // eliminamos hosts
  pathName =  pathName.replace('https://','');
  pathName =  pathName.replace('http://','');
  pathName =  pathName.replace('prod.cms.col.movistar.es','');
  pathName =  pathName.replace('qa.cms.col.movistar.es','');
  pathName =  pathName.replace('www.movistar.es','');
  pathName =  pathName.replace('col10mgmt.tsm.inet','');
  pathName =  pathName.replace('movistar.es','');
  pathName =  pathName.replace('//','/');

  return `${API}${pathName}.${extension}?oe=${oe}`;
};

let API = "{host}/api/v2/get-pic";
const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
// Cambio host de backend segun entorno


if (currentEnv === "prod") {
  API = API.replace("{host}", "https://ssr.col.movistar.es");
} else if (currentEnv === "qa" || process.env.NEXT_PUBLIC_COL10IMAGES === "false") {
  API = API.replace("{host}", "https://dev.ssr.col.movistar.es");
  // API = API.replace("{host}", "https://ssr.col.movistar.es");
} else {
  API = "https://col10mgmt.tsm.inet";
}


const getExtensionOfSrc = (src) => {
  const srcSplit = src.split(".");
  const extension = srcSplit.pop();
  return extension;
}

const getImageId = (entryPoint = "") => {
  let tmp = entryPoint.split(".");
  tmp = tmp[tmp.length - 1];
  tmp = tmp.split("-");
  return tmp[tmp.length - 1];
};



const Imagen = ({
  src,
  alt,
  fill,
  width,
  height,
  objectFit,
  objectPosition,
  className,
  custoObjectInfo,
  cyData,
  priority,
  onLoadCapture,
  onLoadingComplete,
  display,
}) => {
  if (!src || !display) {
    return null;
  }

  const objectStyle = {
    objectFit: objectFit ? objectFit : undefined,
    objectPosition: objectPosition ? objectPosition : undefined,
  };

  // Classname
  const finalClassName = `image${objectFit ? ` object-fit--${objectFit}` : ""}${
    objectPosition ? ` object-fit--${objectPosition}` : ""
  } ${className}`;

  const mainExtension = getExtensionOfSrc(src)



  return (
    <>
      {custoObjectInfo && (
        <span
          className={`image image-${getImageId()} custo-editable`}
          onClick={() => custoObjectInfo.handler(custoObjectInfo.entryPoint)}
        >
          {custoObjectInfo.entryPoint}
        </span>
      )}
      <picture>
        {mainExtension !== 'svg' && VALID_EXTENSIONS.map((extension) => {
          return <source srcSet={createExtensionImage(src, extension)} type={`image/${extension}`} />
        })}
        <Image
          src={createExtensionImage(src, getExtensionOfSrc(mainExtension))}
          style={objectStyle}
          alt={alt}
          width={width}
          height={height}
          fill={fill}
          unoptimized
          className={finalClassName}
          data-cy={cyData}
          priority={priority}
          onLoadCapture={onLoadCapture}
          onLoadingComplete={onLoadingComplete}
        />
      </picture>
    </>
  );
};

Imagen.propTypes = {
  /**
   * Url de la imagen.
   */
  src: PropTypes.string.isRequired,
  /**
   * Texto alternativo de la imagen.
   */
  alt: PropTypes.string.isRequired,
  /**
   * Ancho en píxeles de la imagen. Obligatorio excepto cuando se especifica la propiedad fill.
   */
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Alto en píxeles de la imagen. Obligatorio excepto cuando se especifica la propiedad fill.
   */
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Estirará la imagen para ajustarse al contenedor padre en lugar de usar 'width' y 'height'. Cuando es 'true' es OBLIGATORIO asignarle al contenedor padre
   * uno de los siguientes estilos: position: "relative", position: "fixed" o position: "absolute".
   */
  fill: PropTypes.bool,
  /**
   * Establece cómo se debe redimensionar el contenido, para que se ajuste a su contenedor.
   */
  objectFit: PropTypes.oneOf(["fill", "contain", "cover", "none", "scale-down"]),
  /**
   * Especifica la alineación del contenido del elemento dentro del elemento padre.
   */
  objectPosition: PropTypes.string,
  /**
   * Clase para añadirle estilos extras al icono.
   */
  className: PropTypes.string,
  /**
   * Para quitar loading-lazy.
   */
  priority: PropTypes.bool,
  /**
   * Objeto para la customización del icono en dev.
   */
  custoObjectInfo: PropTypes.shape({
    componentId: PropTypes.string,
    componentInstance: PropTypes.string,
    editFunction: PropTypes.func,
  }),
  cyData: PropTypes.string,
  /**
   * Booleano para controlar que se pinte o no el componente
   */
  display: PropTypes.bool,
};

Imagen.defaultProps = {
  fill: false,
  custoObjectInfo: null,
  priority: false,
  className: "",
  cyData: "",
  onLoadCapture: null,
  onLoadingComplete: null,
  display: true,
};

export default Imagen;
